import { apiInstance } from "./api"

const endpoint = "/contract"

export const getContract = async () => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.get(`${endpoint}`)

  return response.data
}

export const getContractStats = async () => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.get(`${endpoint}/stats`)

  return response.data
}


export const changeContract = async (data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/change-contract`, data)

  return response.data
}

export const extendContract = async (data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/extend-contract`, data)

  return response.data
}

export const getContractDeactivationStatus = async () => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.get(`${endpoint}/check/deactivation`)

  return response.data
}